<template>
  <div class="home_main" ref="homeMain">
    <div class="new_list_body">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <van-cell v-for="item,index in newslist" :key="index" class="news_list_item" @click="goToDetail(item)">
          <van-row>
            <van-col :span="7">
              <van-image class="vant_image" :src="imgBaseUrl + item.cover" width="100" height="100" :error-icon="backImg"></van-image>
            </van-col>
            <van-col :span="17">
              <div style="height: 100px">
                <div style="height: 33%;line-height: 33px;">
                  <span style="font-weight: bold;">通知类型</span>：{{getTypeName(item.type)}}
                </div>
                <div style="height: 33%;line-height: 33px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                  <span style="font-weight: bold;">通知标题</span>：{{item.title}}
                </div>
                <div style="height: 33%;line-height: 33px;">
                  <span style="font-weight: bold;">发布时间</span>：{{item.createTime}}
                </div>
              </div>
            </van-col>
          </van-row>
        </van-cell>
      </van-list>
      <!-- <div v-for="item,index in newslist" :key="index" class="news_list_item" @click="goToDetail(item)">
        <van-row>
          <van-col :span="7">
            <van-image class="vant_image" :src="imgBaseUrl + item.cover" width="100" height="100" :error-icon="backImg"></van-image>
          </van-col>
          <van-col :span="17">
            <div style="height: 100px">
              <div style="height: 33%;line-height: 33px;">
                <span style="font-weight: bold;">通知类型</span>：{{getTypeName(item.type)}}
              </div>
              <div style="height: 33%;line-height: 33px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                <span style="font-weight: bold;">通知标题</span>：{{item.title}}
              </div>
              <div style="height: 33%;line-height: 33px;">
                <span style="font-weight: bold;">发布时间</span>：{{item.createTime}}
              </div>
            </div>
          </van-col>
        </van-row>
      </div> -->
    </div>
  </div>
</template>
<script>
import config from '@/config';
import backImg from "@/assets/images/R-C.jpg";
import {newsPage} from '@/api/news'
export default {
  data(){
    return{
      newslist: [],
      backImg: backImg,
      imgBaseUrl: config.imgBaseUrl,
      type: '',
      pageNum: 1,
      totalPage: 1,
      loading: true,
      finished: false,
      pageSize: 15,
    }
  },
  created(){
    this.type = this.$route.query.type,
    this.getnewsList();
  },
  methods:{
    onLoad(){
      this.loading = true;
      this.pageNum = this.pageNum + 1;
      console.log('*****************************')
      if (!this.finished) {
        this.getnewsList();
      }
    },
    getTypeName(type){
      if (type == 'property') {
        return '社区通知'
      }else if (type == 'trade') {
        return '商业信息'
      }else if (type == 'tissue') {
        return '红色组织'
      }else if (type == 'notice') {
        return '社区新闻'
      }else if (type == 'news') {
        return '社区公告'
      }
    },
    getnewsList(){
      newsPage({
        type: this.type,
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }).then(res=>{
        if (res) {
          this.loading = false;
          var l = res.data.records;
          this.newslist = this.newslist.concat(l);
          // this.newslist = res.data.records;
          this.totalPage = res.data.pages;
          if(this.pageNum >= this.totalPage){
            this.finished = true;
          }
        }
      })
    },
    goToDetail(item){
      console.log(item);
      this.$router.push({
        path: '/news/inDetail',
        query: {
          type: item.type,
          id: item.id
        }
      })
    }
  }
}
</script>
<style>
.van-icon__image{
  width: 100px;
  height: 100px;
}
</style>
<style scoped>
.news_list_item{
  padding: 8px;
  border-bottom: 1px solid #cecece;;
}
.new_list_body{
  background-color: #fff;
  margin-top: 8px;
}
.new_list_title{
  font-weight: bold;
  color: #1989fa;
  padding: 8px 0px 8px 12px;
  border-bottom: 2px solid #cecece;;
}
.home_main{
  background-color: #eeecec;
}
</style>